import { DEFAULT_SITE } from './siteDefaults';

function strPrefer(a, b, fallback) {
  if (typeof a === 'string' && a.trim()) return a.trim();
  if (typeof b === 'string' && b.trim()) return b.trim();
  return typeof fallback === 'string' ? fallback : '';
}

const FALLBACK_SECTION_LABEL = 'Agri Intelligence';
const FALLBACK_SECTION_TITLE = 'From Soil to Soul, We Grow Naturally';

const FALLBACK_CENTER_SRC =
  'https://agrezen.zozothemes.com/wp-content/uploads/2025/10/shape-15-1200x1177.webp';
const FALLBACK_CENTER_ALT = 'Agricultural cycle: soil, growth, harvest, and stewardship';

const FALLBACK_FEATURES = [
  {
    step: '01',
    title: 'Data-Driven Agriculture',
    text: 'Use field data, soil insight, and seasonal trends to guide every input—so decisions stay grounded in what your land actually needs.',
    ctaLabel: 'More Details',
    ctaHref: '#contact',
  },
  {
    step: '02',
    title: 'Planting Material',
    text: 'Trusted seeds and planting stock, sourced and handled with care from selection to sowing—supporting strong emergence and healthy stands.',
    ctaLabel: 'More Details',
    ctaHref: '#contact',
  },
];

function resolveFeature(stored, bundled, index) {
  const s = stored && typeof stored === 'object' ? stored : {};
  const b = bundled && typeof bundled === 'object' ? bundled : {};
  const f = FALLBACK_FEATURES[index] || FALLBACK_FEATURES[0];
  return {
    step: strPrefer(s.step, b.step, f.step),
    title: strPrefer(s.title, b.title, f.title),
    text: strPrefer(s.text, b.text, f.text),
    ctaLabel: strPrefer(s.ctaLabel, b.ctaLabel, f.ctaLabel),
    ctaHref: strPrefer(s.ctaHref, b.ctaHref, f.ctaHref),
  };
}

/** Agri Intelligence section copy (headlines, center graphic, two columns) from API / bundled defaults. */
export function resolveAgriIntelligence(site) {
  const d =
    DEFAULT_SITE.agriIntelligence && typeof DEFAULT_SITE.agriIntelligence === 'object'
      ? DEFAULT_SITE.agriIntelligence
      : {};
  const x =
    site?.agriIntelligence && typeof site.agriIntelligence === 'object' ? site.agriIntelligence : {};
  const storedFeatures = Array.isArray(x.features) ? x.features : [];
  const bundledFeatures = Array.isArray(d.features) ? d.features : [];
  return {
    sectionLabel: strPrefer(x.sectionLabel, d.sectionLabel, FALLBACK_SECTION_LABEL),
    sectionTitle: strPrefer(x.sectionTitle, d.sectionTitle, FALLBACK_SECTION_TITLE),
    centerImageSrc: strPrefer(x.centerImageSrc, d.centerImageSrc, FALLBACK_CENTER_SRC),
    centerImageAlt: strPrefer(x.centerImageAlt, d.centerImageAlt, FALLBACK_CENTER_ALT),
    features: [0, 1].map((i) => resolveFeature(storedFeatures[i], bundledFeatures[i], i)),
  };
}
